import { render, staticRenderFns } from "./GymRouteClimbingStyles.vue?vue&type=template&id=b29e6142"
import script from "./GymRouteClimbingStyles.vue?vue&type=script&lang=js"
export * from "./GymRouteClimbingStyles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports